import React, { useEffect, useState } from "react";

//UI Material
import { Button, Grid } from "@mui/material";

//Local components
import QuoteSummary from "../Components/quotes-page/QuoteSummary";
import ProductToQuote from "../Components/quotes-page/ProductToQuote";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Material Icons
import { ArrowBackIos, Refresh } from "@mui/icons-material";
import ElementCard from "../ProComponents/ElementCard";
import DataLoader from "../Components/basics/DataLoader";
import ErrorBox from "../Components/ErrorBox";
import NexaCutoverNotice from "../Components/NexaCutoverNotice";

export default function NewQuote() {
  //Type of payment methods
  const paymentMethods = [
    "Contado",
    "Crédito",
    "50% por adelantado, 50% contra entrega",
  ];

  // ==========> Component States <==========
  //State for products to quote array
  const [productosToQuote, setProductosToQuote] = useState([]);
  //State for quote currency selection
  const [currency, setCurrency] = useState("USD");
  //State for products list
  const [productsList, setProductsList] = useState([]);
  //State for error un products extraction
  const [dataError, setDataError] = useState(false);

  const quoteToEdit = JSON.parse(localStorage.getItem("quote"));

  useEffect(() => {
    if (quoteToEdit) {
      console.log(quoteToEdit);
      setProductosToQuote(productosToQuote.concat(quoteToEdit.products));
      if (quoteToEdit.billing.currency) {
        setCurrency(quoteToEdit.billing.currency);
      }
    }
  }, []);

  useEffect(() => {
    getProductsList();
  }, []);

  //Function to get orders list
  const getProductsList = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/products/get`, {
        howMany: 500,
      });
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setProductsList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setProductsList([]);
      setDataError(true);
    }
  };

  // ==========> Component <==========
  if (dataError) {
    return (
      <Grid container sx={{ padding: 2 }} spacing={2}>
        <Grid item xs={12}>
          <NexaCutoverNotice />
        </Grid>
        <Grid item xs={12}>
          <ErrorBox />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ padding: 2 }} spacing={2}>
      <Grid item xs={12}>
        <NexaCutoverNotice />
      </Grid>
      <Grid item xs={12} align="left">
        <Button startIcon={<ArrowBackIos />} href="/customer-service">
          {"Volver a servicio al cliente"}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <ElementCard
          ops={{
            title: "Creador de Cotizaciones",
            details: [
              "Genera nuevas cotizaciones de manera ágil, personalizando los productos o servicios según las necesidades del cliente.",
            ],
          }}
        />
      </Grid>
      <Grid item xs={12} align="left">
        <Button
          endIcon={<Refresh />}
          variant="outlined"
          sx={{ color: "secondary" }}
          onClick={() => {
            localStorage.removeItem("quote");
            window.location.reload();
          }}
        >
          {"Refrescar datos"}
        </Button>
      </Grid>

      {productsList.length > 0 ? (
        <Grid item xs={12} lg={6}>
          <ProductToQuote
            data={productosToQuote}
            setData={setProductosToQuote}
            setCurrency={setCurrency}
            currency={currency}
            products={productsList}
          />
        </Grid>
      ) : (
        <Grid item xs={12} lg={6}>
          <DataLoader />
        </Grid>
      )}

      <Grid item xs={12} lg={6}>
        <QuoteSummary
          data={productosToQuote}
          currency={quoteToEdit?.billing.currency || currency}
          existingQuote={{
            notes: quoteToEdit?.notes || "",
            billing: {
              discountPercentage: quoteToEdit?.billing?.discountPercentage || 0,
              taxesPercentage: quoteToEdit?.billing?.taxesPercentage || 13,
              paymentMethod: quoteToEdit?.billing?.paymentMethod
                ? paymentMethods.indexOf(quoteToEdit.billing.paymentMethod)
                : 0,
              aditional: quoteToEdit?.billing?.aditional || "",
            },
            client: {
              name: quoteToEdit?.client?.name || "",
              email: quoteToEdit?.client?.email || "",
              phone: quoteToEdit?.client?.phone || "",
              id: quoteToEdit?.client?.id || "",
            },
            products: [],
          }}
          setData={setProductosToQuote}
        />
      </Grid>
    </Grid>
  );
}
